module.exports = __webpack_public_path__ + "img/山东大学.41c19fe1.png";